<template>
  <v-container>
    <v-form class="col-lg-8 col-11 contact-form lime lighten-5">
      <v-row>
        <v-text-field label="Email" hint="max 30 characters" />
      </v-row>

      <v-row>
        <v-text-field label="Name" hint="max 30 characters" />
      </v-row>

      <v-row>
        <v-text-field label="Title" hint="max 50 characters" />
      </v-row>

      <v-row>
        <v-textarea label="message" hint="max 300 characters" />
      </v-row>

      <v-row>
        <v-btn>Send</v-btn>
      </v-row>

      <br />
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "contact-form"
}
</script>

<style scoped>
.contact-form {
  padding: 1.5rem;
  margin-left: auto;
  margin-right: auto;
  border-radius: 0.5rem;
  box-shadow: -0.5px 1.5px 0.25rem 0.5px rgba(0,0,0,0.25)
}
</style>
